import React from 'react';
import { Box } from 'reflexbox';

import { SettingHeader, SettingsContainer, SettingsLabel } from '../components/BranchComponents';
import GoogleMap from '../../GoogleMap/GoogleMapContainer';
import DeliveryDaysList from './DeliveryDaysList';
import DeliveryTimeslotsList from './DeliveryTimeslotsList';
import BranchStaticField from '../components/BranchStaticField';

import { formatDate } from '../../../utils/formatters';

const DeliveryPartnerSettings = ({ pharmacy, onChange, onValidationError }) => {
  const { delivery_partner, delivery } = pharmacy;
  const { go_live_date } = delivery || {};
  const { days, timeslots } = delivery_partner || {};

  const dayChangeHandler = (updatedDay) => {
    let updatedDays = days ? [...days] : [];

    if (updatedDays.includes(updatedDay)) {
      updatedDays = updatedDays.filter(day => day !== updatedDay);
    } else {
      updatedDays.push(updatedDay);
    }

    if (updatedDays.length === 0) return onValidationError('At least one delivery day must be selected');

    onChange('delivery_partner.days', updatedDays);
  };

  const timeslotChangeHandler = (updatedTimeslot, checked) => {
    let updatedTimeslots = timeslots ? [...timeslots] : [];

    if (checked) {
      if (timeslots && timeslots.some(timeslot => timeslot.start === updatedTimeslot.start)) {
        return onValidationError('Timeslot already exists');
      }
      updatedTimeslots.push(updatedTimeslot);
    } else {
      updatedTimeslots = updatedTimeslots.filter(
        timeslot => !(updatedTimeslot.start === timeslot.start && updatedTimeslot.end === timeslot.end)
      );
    }

    onChange('delivery_partner.timeslots', updatedTimeslots);
  };

  return (
    <SettingsContainer>
      {pharmacy &&
      <>
        <SettingHeader>Local delivery settings</SettingHeader>
        {go_live_date && <BranchStaticField mt={24} label="Go live date" value={formatDate(go_live_date)} />}
        <SettingsLabel>Pharmacy location and delivery geofence</SettingsLabel>
        <Box pt={2}><GoogleMap /></Box>
        <DeliveryDaysList deliveryDays={days} onChange={dayChangeHandler} />
        <DeliveryTimeslotsList timeslots={timeslots} onChange={timeslotChangeHandler} />
      </>
      }
    </SettingsContainer>
  );
};

export default DeliveryPartnerSettings;
